<template>
  <v-container
    id="blog"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-row>
      <base-material-card
        icon="mdi-newspaper-plus"
        class="px-5 py-3"
        width="98%"
      >
        <template v-slot:after-heading>
          <span class="card-title font-weight-light mr-4">
            Blog Editor
          </span>
        </template>
        <template>
          <v-card>
            <v-card-title>
              <v-dialog
                v-model="dialog"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="info"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    small
                    v-on="on"
                  >
                    New Item
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Edit News</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-menu
                            v-model="showdatepicker"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="editedItem.data_evento"
                                label="Data evento"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              v-model="editedItem.data_evento"
                              @input="showdatepicker = false"
                            />
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <span class="text-caption mr-2">
                            Priorita
                          </span>
                          <v-icon

                            size="20"
                            :color="editedItem.priorita==0?'gray':editedItem.priorita==1?'blue':editedItem.priorita==2?'green':editedItem.priorita==3?'orange':editedItem.priorita>=4?'red':''"
                          >
                            {{ [0].includes(editedItem.priorita)?'mdi-network-strength-outline':'' }}
                            {{ [1,2,3,4].includes(editedItem.priorita)?'mdi-network-strength-'+editedItem.priorita:'' }}
                            {{ [5].includes(editedItem.priorita)?'mdi-network-strength-4':'' }}
                          </v-icon>
                          <!-- <v-rating
                            v-model="editedItem.priorita"
                            length="4"
                            dense
                            background-color="orange lighten-3"
                            color="orange"
                            size="18"
                          /> -->
                          <v-slider
                            v-model="editedItem.priorita"
                            color="gray"
                            track-color="gray"
                            :track-fill-color="editedItem.priorita==0?'gray':editedItem.priorita==1?'blue':editedItem.priorita==2?'green':editedItem.priorita==3?'orange':editedItem.priorita>=4?'red':''"
                            thumb-label
                            :max="4"
                            step="1"
                            ticks="always"
                            tick-size="4"
                          />
                        </v-col>

                        <v-col
                          cols="12"
                        >
                          <v-text-field
                            v-model="editedItem.titolo"
                            label="Titolo"
                          />
                        </v-col>
                        <v-col cols="12">
                          <!-- <v-textarea
                            v-model="editedItem.testo"
                            hide-details="auto"
                            outlined
                            label="Testo Nota"
                          /> -->
                          <vue-editor
                            v-model="editedItem.testo"
                            :custom-modules="customModulesForEditor"
                            :editor-options="editorSettings"
                          />
                          <!-- <emoji-picker @emoji="insert">
                            <div
                              slot="emoji-invoker"
                              slot-scope="{ events: { click: clickEvent } }"
                              @click.stop="clickEvent"
                            >
                              <span
                                ref="btn_emoji"
                                type="button"
                              >😏</span>
                            </div>
                            <div
                              slot="emoji-picker"
                              slot-scope="{ emojis, insert, display }"
                            >
                              <div>
                                <div
                                  v-for="(emojiGroup, category) in emojis"
                                  :key="category"
                                >
                                  <h5>{{ category }}</h5>
                                  <div>
                                    <span
                                      v-for="(emoji, emojiName) in emojiGroup"
                                      :key="emojiName"
                                      style="cursor:pointer"
                                      :title="emojiName"
                                      @click="insert(emoji);$refs.btn_emoji.click()"
                                    >{{ emoji }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </emoji-picker> -->
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="dialogDelete"
                max-width="500px"
              >
                <v-card>
                  <v-card-title class="text-h5">
                    Are you sure you want to delete this item?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeDelete"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="deleteItemConfirm"
                    >
                      OK
                    </v-btn>
                    <v-spacer />
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-spacer />
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="tabdata"
              :search="search"
              :items-per-page="15"
              multi-sort
              :sort-by="['priorita','data_evento']"
              :sort-desc="[true,true]"
              show-expand
              single-expand
              :expanded="expanded"
            >
              <template v-slot:item.priorita="{item}">
                <v-icon

                  size="20"
                  :color="item.priorita==0?'gray':item.priorita==1?'blue':item.priorita==2?'green':item.priorita==3?'orange':item.priorita>4?'red':''"
                >
                  {{ [0].includes(item.priorita)?'mdi-network-strength-outline':'' }}
                  {{ [1,2,3,4].includes(item.priorita)?'mdi-network-strength-'+item.priorita:'' }}
                  {{ [5].includes(item.priorita)?'mdi-network-strength-4':'' }}
                </v-icon>
                <!-- <v-rating
                  dense
                  :value="item.priorita"
                  background-color="orange lighten-3"
                  color="orange"

                  size="18"
                  readonly
                /> -->
              </template>
              <template v-slot:expanded-item="{ item }">
                <td
                  :colspan="headers.length"
                  class="pa-5"
                >
                  <p class="mb-3 text-caption">
                    [id: {{ item.id }}] <i>Scritto da: {{ item.user }}</i>
                  </p>

                  <p v-html="item.testo.trim().replace(/(?:\r\n|\r|\n)/g, '<br />')" />
                </td>
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item.user===auth.display_name || auth.id <=4">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon

                    small
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                </div>
              </template>
              <template v-slot:no-data>
                Nessuna news attiva
              </template>
            </v-data-table>
          </v-card>
        </template>
      </base-material-card>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '../../plugins/engine'
  import { VueEditor } from 'vue2-editor'
  import ImageResize from 'quill-image-resize-vue'

  export default {
    name: 'Blog',
    components: { VueEditor },
    props: {

    },
    data () {
      return {
        loading: false,
        show: true,
        dialog: false,
        dialogDelete: false,
        showdatepicker: false,
        expanded: [],
        tabdata: [],
        search: '',
        customModulesForEditor: [
          { alias: 'imageResize', module: ImageResize },
        ],
        editorSettings: {
          modules: {
            imageResize: {},
          },
        },
        headers: [
          { text: '', value: 'data-table-expand', sortable: false },
          { text: 'id', value: 'id', align: ' d-none' },
          { text: 'data_evento', value: 'data_evento' },
          { text: 'priorità', value: 'priorita', align: 'center' },
          { text: 'titolo', value: 'titolo' },
          { text: 'Actions', value: 'actions', sortable: false },

        ],
        filter: 'test',
        editedIndex: -1,
        editedItem: {
          data_evento: '',
          priorita: 0,
          posizione: 0,
          titolo: '',
          testo: '',
        },
        defaultItem: {
          data_evento: '',
          priorita: 0,
          posizione: 0,
          titolo: '',
          testo: '',
        },
      }
    },
    computed: {
      ...mapState(['auth']),

    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    mounted () {
      this.loadBlog()
    },
    beforeDestroy () {

    },
    methods: {
      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      loadBlog: function () {
        engine.getNotes()
          .then((result) => {
            console.log('blog', result)
            this.tabdata = result.notes
          })
      },
      setNotes (item) {
        item.user = this.auth.display_name
        engine.setNotes(item)
          .then((result) => {
            console.log('setNotes', result)
            this.loadBlog()
            this.close()
          })
      },
      delNotes (item) {
        item.user = this.auth.display_name
        engine.delNotes(item)
          .then((result) => {
            console.log('setNotes', result)
            this.loadBlog()
            this.close()
          })
      },
      editItem (item) {
        this.editedIndex = this.tabdata.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.tabdata.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.tabdata.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.delNotes(this.editedItem)
          // this.editedItem = Object.assign({}, this.defaultItem)
          // this.editedIndex = -1
        })
      },

      save () {
        console.log('save blog', this.editedIndex, this.editedItem)
        if (!this.editedItem.data_evento) {
          alert('Manca data_evento')
          return
        }
        if (!this.editedItem.titolo) {
          alert('Manca titolo')
          return
        }
        if (!this.editedItem.testo) {
          alert('Manca testo')
          return
        }

        this.setNotes(this.editedItem)
      },

    },

  }
</script>
<style >
strong {
 font-weight: bold;
}
</style>
